import { formatCurrency } from '@ps/web-poker-utils';

import i18n from '../../i18n';
import type { Language } from '../../types';
import { AttributeKey } from '../types';

interface LobbyNewsContentData {
  'payout-amount'?: string;
}

// TODO: fix naming conventions
// eslint-disable-next-line @typescript-eslint/naming-convention
interface ISagAttributes {
  buyIn: number;
  rake: number;
  currency: number | string;
  maxPrizePool: number;
  isPlayMoney: number;
  players: string;
  scalePM: number;
  lobbyNewsContentData?: LobbyNewsContentData | null;
  shortenRM?: boolean;
}

function isLobbyNewsData(data: LobbyNewsContentData): boolean {
  return !!data && !!data['payout-amount'];
}

function removeHtmlMarkup(amountString: string): string {
  const result = />(.*?)</.exec(amountString);

  if (result && result[1]) {
    return result[1];
  }

  return amountString;
}

export default function sagAttrFormater(
  {
    buyIn,
    rake,
    currency,
    maxPrizePool,
    isPlayMoney,
    players,
    scalePM,
    lobbyNewsContentData,
    shortenRM
  }: ISagAttributes,
  language: Language
) {
  const i18nInstance = i18n(language);

  return [
    {
      name: i18nInstance('TXTWBCLI_Buy_In'),
      value: buyIn
        ? formatCurrency(buyIn + rake, currency, { separators: true, isPlayMoney, scalePM })
        : i18nInstance('TXTWBCLI_Freeroll'),
      key: AttributeKey.buyIn
    },
    {
      name: i18nInstance('TXTWBCLI_Players'),
      value: players,
      key: AttributeKey.players
    },
    {
      name: i18nInstance('TXTWBCLI_Win_Up_To'),
      // @ts-ignore TODO: fix types
      value: isLobbyNewsData(lobbyNewsContentData)
        ? // @ts-ignore TODO: fix types
          removeHtmlMarkup(lobbyNewsContentData['payout-amount'])
        : formatCurrency(maxPrizePool, currency, {
            separators: true,
            shorten: true,
            isPlayMoney,
            scalePM,
            shortenRM,
            locale: language
          }),
      key: AttributeKey.winUpTo
    }
  ];
}

export const getSagGameAttributes = (
  {
    buyIn,
    rake,
    currency,
    maxPrizePool,
    isPlayMoney,
    players,
    scalePM,
    lobbyNewsContentData,
    shortenRM
  }: ISagAttributes,
  language: Language
): {
  buyIn: string;
  players: string;
  winUpTo: string;
} => {
  const attributes = sagAttrFormater(
    {
      buyIn,
      rake,
      currency,
      maxPrizePool,
      isPlayMoney,
      players,
      scalePM,
      lobbyNewsContentData,
      shortenRM
    },
    language
  );

  return attributes.reduce(
    (acc, attribute) => {
      // @ts-ignore TODO: fix types
      acc[AttributeKey[attribute.key]] = attribute.value;
      return acc;
    },
    {
      buyIn: '',
      players: '',
      winUpTo: ''
    }
  );
};
